export const DEFAULT_REWARD_ENABLED = true

export function shouldConfirmClearBudget(args: {
  current: boolean
  next: boolean
  budgetConfigured: boolean
}): boolean {
  return args.budgetConfigured && args.current && !args.next
}

type PublishConfigWithLegacy = {
  rewardEnabled?: boolean
  instrumentRewardChoice?: string
}

/** Maps API `publishConfig` (supports legacy `instrumentRewardChoice` in Mongo). */
export function rewardEnabledFromPublishConfig(
  data: PublishConfigWithLegacy | null | undefined,
): boolean {
  if (data?.rewardEnabled != null) return data.rewardEnabled
  if (data?.instrumentRewardChoice === 'rewards') return true
  if (data?.instrumentRewardChoice === 'no_rewards') return false
  return DEFAULT_REWARD_ENABLED
}
